[
    "//cdn.cian.site/finance/finance-offer-card-calculator/widget.js",
    "//cdn.cian.site/finance/finance-input-slider/widget.js",
    "//cdn.cian.site/finance/finance-input-with-slider/widget.js",
    "//cdn.cian.site/finance/finance-annuity/widget.js",
    "//cdn.cian.site/finance/finance-years-addorment/widget.js",
    "//cdn.cian.site/finance/finance-annuity-required-income/widget.js",
    "//cdn.cian.site/finance/finance-credit-amount/widget.js",
    "//cdn.cian.site/finance/finance-percent-view/widget.js",
    "//cdn.cian.site/finance/cian-moblie-input-with-slider/widget.js",
    "//cdn.cian.site/finance/cian-finance-credit-rate-control/widget.js",
].forEach(href => {
    if (!document.querySelector('script[src="' + href + '"]')) {
        let element = document.createElement('script');
        element.type = "text/javascript";
        element.charset = 'UTF-8';
        element.src = href;
        document.head.appendChild(element);
    }
});

if (!customElements.get('cian-finance-credit-rate-display')) customElements.define('cian-finance-credit-rate-display', class extends HTMLElement {
    static get observedAttributes() {
        return ['rate'];
    }

    attributeChangedCallback(name, old, _new) {
        this.dispatchEvent(new CustomEvent('rate-updated', {bubbles: true, detail: {value: Number.parseFloat(_new)}}));
        const value = _new.toString().replace(/[.]/g, ",")
        this.innerHTML = value.substring(0, value.indexOf(',') + 3) + (this.hasAttribute('suffix') ? this.getAttribute("suffix") : " %");
    }
});

if (!customElements.get('cian-finance-cookie-state-saver')) customElements.define('cian-finance-cookie-state-saver', class extends HTMLElement {
    static get observedAttributes() {
        return ['initial-payment', 'term', 'closed-value', 'payroll', 'special-program'];
    }

    attributeChangedCallback(name, old, _new) {
        let item = localStorage.getItem('calculatorParameters') ? JSON.parse(localStorage.getItem('calculatorParameters')) : {};
        item[name] = _new;
        localStorage.setItem('calculatorParameters', JSON.stringify(item));
    }
});

function handleAnnuityPaymentTableClick(element, e) {
    const x = e.target.closest('[annuity-payment-table]');
    const customEvent = new CustomEvent('SHOW_PAYMENT_TABLE', {bubbles: true});
    customEvent.term = Number.parseFloat(x.getAttribute("term"));
    customEvent.rate = Number.parseFloat(x.getAttribute("rate"));
    customEvent.initialPayment = Number.parseFloat(x.getAttribute("initial-payment"));
    customEvent.price = Number.parseFloat(x.getAttribute("price"));
    element.dispatchEvent(customEvent);
    e.stopPropagation();
}


if (!customElements.get('cian-finance-calculator')) customElements.define('cian-finance-calculator', class extends HTMLElement {
    connectedCallback() {
        const render = (calculatorSettings) => {
            let price = this.hasAttribute('price') ? Number.parseInt(this.getAttribute('price')) : 1000000;
            const item = localStorage.getItem('calculatorParameters') ? JSON.parse(localStorage.getItem('calculatorParameters')) : {};
            item.payroll = item.payroll || false;
            item.initialPayment = item.initialPayment || 0.1 * price;
            item.term = item.term || 20;
            const platform = window.innerWidth < 768 ? 'mobile' : 'desktop';
            const storedState = Object.getOwnPropertyNames(item).map(k => {
                return !!item[k] && k + "=" + encodeURIComponent(item[k]);
            }).filter(Boolean).join("&");
            const settings = Object.getOwnPropertyNames(calculatorSettings).map(k => {
                return !!calculatorSettings[k] && k + "=" + encodeURIComponent(calculatorSettings[k]);
            }).filter(Boolean).join("&");

            fetch(`https://content-distribution-calculator.content.cian.ru/${platform}/calculator?` +
                `price=${price}&` + storedState + "&" + settings
            ).then((r) => {
                r.text().then(t => {
                    this.innerHTML = t;
                    this.dispatchEvent(new CustomEvent('CALCULATOR_RENDERED', {bubbles: true, detail: this.getInputParameters()}))
                });
            });
        };
        this.makeATry(render);
        this.addEventListener('change', (e) => this.onChange(e));
        this.addEventListener('change-pv', (e) => this.onChange(e));
        this.addEventListener('change-term', (e) => this.onChange(e));
        this.addEventListener('change-payroll', (e) => this.onChange(e));
        this.addEventListener('change-special-program', (e) => this.onChange(e));
        this.addEventListener('click', (e) => {
            if (e.target.closest('[annuity-payment-table]')) {
                handleAnnuityPaymentTableClick(this, e);
            }
        });
        this.dispatchEvent(new CustomEvent('CALCULATOR_INIT', {bubbles: true, detail: this.getInputParameters()}))
    }

    onChange(e) {
        this.makeATry((settings) => {
            console.log(settings);
            let customEvent = new CustomEvent('change-rate');
            customEvent.value = settings.rate;
            this.querySelector('finance-offer-card-calculator').dispatchEvent(customEvent)
            const price = this.hasAttribute('price') ? Number.parseInt(this.getAttribute('price')) : 1000000;
            let min = Math.round(price * settings.minInitialPayment);
            let minRatio = Math.round(100 * settings.minInitialPayment)/100;
            let max = Math.round(price * settings.maxInitialPayment);
            let maxRatio = Math.round(100 * settings.maxInitialPayment)/100;
            const ipSlider = this.querySelector('[custom-event="change-pv"]');
            if (ipSlider) {
                if (Number.parseInt(ipSlider.getAttribute('slider-min')) !== min) {
                    ipSlider.setAttribute('slider-min', min)
                }
                if (Number.parseInt(ipSlider.getAttribute('slider-max')) !== max) {
                    ipSlider.setAttribute('slider-max', max)
                }
            }
            const ipScale = this.querySelector('percent-scale');
            if (ipScale) {
                if (Number.parseInt(ipScale.getAttribute('min')) !== minRatio) {
                    ipScale.setAttribute('min', minRatio)
                }
                if (Number.parseInt(ipScale.getAttribute('max')) !== maxRatio) {
                    ipScale.setAttribute('max', maxRatio)
                }
            }
            let minTerm = Math.round(settings.minTerm);
            let maxTerm = Math.round(settings.maxTerm);
            const termSlider = this.querySelector('[custom-event="change-term"]');
            if (termSlider) {
                if (Number.parseInt(termSlider.getAttribute('slider-min')) !== minTerm) {
                    termSlider.setAttribute('slider-min', minTerm);
                }
                if (Number.parseInt(termSlider.getAttribute('slider-max')) !== maxTerm) {
                    termSlider.setAttribute('slider-max', maxTerm);
                }
            }
            const termScale = this.querySelector('term-scale');
            if (termScale) {
                if (Number.parseInt(termScale.getAttribute('min')) !== minTerm) {
                    termScale.setAttribute('min', minTerm);
                }
                if (Number.parseInt(termScale.getAttribute('max')) !== maxTerm) {
                    termScale.setAttribute('max', maxTerm);
                }
            }
        })
    }

    makeATry(callback) {
        if (window.cian_calculator_find_rate) {
            callback(window.cian_calculator_find_rate(this.getInputParameters()));
        } else {
            setTimeout(() => this.makeATry(callback), 100);
        }
    }

    getInputParameters() {
        const totalFloors = this.hasAttribute('total-floors') && Number.parseInt(this.getAttribute('total-floors'));
        const villageMortgageAllowed = this.hasAttribute('village-mortgage-allowed') && this.getAttribute('village-mortgage-allowed') === '1';
        let price = this.hasAttribute('price') ? Number.parseInt(this.getAttribute('price')) : 1000000;
        const item = localStorage.getItem('calculatorParameters') ? JSON.parse(localStorage.getItem('calculatorParameters')) : {};
        let payrollControll = this.querySelector('cian-finance-credit-rate-control-payroll');
        item.payroll = payrollControll ? payrollControll.getAttribute('selected') === 'true' : item.payroll === "true";
        let specialProgramElement = this.querySelector('custom-credit-rate-control-payroll[special-program]');
        item.specialProgram = specialProgramElement ? specialProgramElement.getAttribute('special-program') : item['special-program'];
        const ipControl = this.querySelector('[custom-event="change-pv"]');
        item.initialPayment = ipControl ? Number.parseInt(ipControl.getAttribute('slider-value')) : item.initialPayment || 0.1 * price;
        const termControl = this.querySelector('[custom-event="change-term"]');
        item.term = termControl ? Number.parseInt(termControl.getAttribute('slider-value')) : item.term || 20;
        return {
            region: this.hasAttribute('region') ? Number.parseInt(this.getAttribute('region')) : 1,
            type: this.getAttribute('type') || 'flat',
            new: this.hasAttribute('new') ? this.getAttribute('new') === "true" : true,
            partner: this.hasAttribute('partner') ? this.getAttribute('partner') === "true" : true,
            builderName: this.getAttribute('builder-name'),
            builderId: this.getAttribute('builder-id'),
            fullAddress: this.hasAttribute('fullAddress') ? JSON.parse(this.getAttribute('fullAddress')) : [],
            price: price,
            payroll: item.payroll,
            initialPayment: item.initialPayment,
            term: item.term,
            specialProgram: item.specialProgram,
            partnerDiscount: this.getAttribute('partner-discount'),
            partnerBaseRate: this.getAttribute('partner-base-rate'),
            totalFloors,
            villageMortgageAllowed
        };
    }
});

if (!customElements.get('finance-offer-card-calculator-magic')) customElements.define('finance-offer-card-calculator-magic', class extends HTMLElement {

    connectedCallback() {
        if (!this.hasAttribute('closed-value')) this.setAttribute('closed-value', false);
        this.addEventListener('click', (e) => {
            if (e.target.closest('[calculator-close-control-area]')) {
                const closed = JSON.parse(this.getAttribute('closed-value'));
                this.setAttribute('closed-value', !closed);
            }
            if (e.target.closest('[scroll-to]')) {
                const scrollTo = e.target.closest('[scroll-to]').getAttribute('scroll-to');
                this.dispatchEvent(new CustomEvent('CIAN_SCROLL_TO', {detail: scrollTo, bubbles: true}));
            }
            if (e.target.closest('[annuity-payment-table]')) {
                handleAnnuityPaymentTableClick(this, e);
            }
            e.stopPropagation();
        })
    }

    static get observedAttributes() {
        return ['closed-value'];
    }

    attributeChangedCallback(name, old, _new) {
        if (old !== _new) {
            const handle = () => {
                const switcher = document.querySelector('div[calculator-close-control]');
                const closableElement = document.querySelector('div[calculator-closable-element]');
                let closed = JSON.parse(_new);
                if (closed) {
                    closableElement.style.display = 'none';
                    switcher.innerHTML = "<svg width=\"16\" height=\"10\" viewBox=\"0 0 16 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                        "<path d=\"M14.252 0.75025C13.989 0.75025 13.728 0.853251 13.531 1.05825L8.00203 6.81625L2.47303 1.05825C2.09003 0.65925 1.45803 0.64625 1.05903 1.03025C0.66103 1.41325 0.64803 2.04725 1.03103 2.44525L7.28103 8.95525C7.65803 9.34825 8.34603 9.34825 8.72303 8.95525L14.973 2.44525C15.356 2.04725 15.343 1.41325 14.945 1.03025C14.751 0.843249 14.501 0.75025 14.252 0.75025Z\" fill=\"#262C40\"/>\n" +
                        "</svg>\n"
                } else {
                    closableElement.style.display = 'grid';
                    switcher.innerHTML = "<svg width=\"16\" height=\"10\" viewBox=\"0 0 16 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                        "                    <path d=\"M14.252 9.24975C13.989 9.24975 13.728 9.14675 13.531 8.94175L8.00203 3.18375L2.47303 8.94175C2.09003 9.34075 1.45803 9.35375 1.05903 8.96975C0.66103 8.58675 0.64803 7.95275 1.03103 7.55475L7.28103 1.04475C7.65803 0.65175 8.34603 0.65175 8.72303 1.04475L14.973 7.55475C15.356 7.95275 15.343 8.58675 14.945 8.96975C14.751 9.15675 14.501 9.24975 14.252 9.24975Z\"\n" +
                        "                          fill=\"#262C40\"/>\n" +
                        "                </svg>"
                }
                this.querySelectorAll('[closed-value]').forEach(v => v.setAttribute('closed-value', closed));
            };
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', handle);
            } else {
                handle();
            }
        }
    }
});

customElements.define('percent-scale', class extends HTMLElement {
    static get observedAttributes() {
        return ['min', 'max']
    }

    connectedCallback() {
        this.addEventListener('click', (e) => {
            const percentElement = e.target.closest('[percent]');
            if(percentElement) {
                const percent = Number.parseFloat(percentElement.getAttribute('percent'));
                const price = Number.parseFloat(percentElement.getAttribute('price'));
                const e = new CustomEvent('change-pv', {bubbles: true});
                e.value = Math.round(price * percent);
                percentElement.dispatchEvent(e);
            }
        });
    }

    attributeChangedCallback() {
        const min = Number.parseFloat(this.getAttribute('min'));
        const max = Number.parseFloat(this.getAttribute('max'));
        if (!Number.isNaN(min) && !Number.isNaN(max)) {
            const start = Math.ceil(min * 10) / 10;
            const stop = Math.floor(max * 10) / 10;
            const steps = Array((stop - start) * 10 + 1).fill(start).map((v, idx) => v + idx * 0.1);
            if ((Math.ceil(min * 100) / 100) !== steps[0]) {
                steps.unshift(Math.ceil(min * 100) / 100);
            }
            if (Math.floor(max * 100) / 100 !== steps[steps.length - 1]) {
                steps.push(Math.floor(max * 100) / 100);
            }
            const div = document.createElement('div');
            div.style.width = '100%';
            div.style.height = '100%';
            div.style.position = 'relative';
            div.style.display = 'flex';
            div.style.justifyContent = 'space-between';
            let scaleHtml = '';
            for(var step of steps) {
                scaleHtml += `
                        <div style="width: 25px; cursor: pointer" percent="${Math.round(step * 100)/100}" price="${this.getAttribute('price')}">${Math.round(step * 100)}%</div>
                    `
            }
            div.innerHTML = scaleHtml;
            this.innerHTML = '';
            this.appendChild(div);30
        }
    }
});
customElements.define('term-scale', class extends HTMLElement {
    static get observedAttributes() {
        return ['min', 'max']
    }

    connectedCallback() {
        this.addEventListener('click', (e) => {
            const percentElement = e.target.closest('[my-term]');
            if(percentElement) {
                const e = new CustomEvent('change-term', {bubbles: true});
                e.value = Number.parseInt(percentElement.getAttribute('my-term'));
                percentElement.dispatchEvent(e);
            }
        });
    }

    attributeChangedCallback() {
        const min = Number.parseFloat(this.getAttribute('min'));
        const max = Number.parseFloat(this.getAttribute('max'));
        if (!Number.isNaN(min) && !Number.isNaN(max)) {
            const start = Math.ceil(min / 5) * 5;
            const stop = Math.floor(max / 5) * 5;
            const steps = Array(Math.round((stop - start) / 5)).fill(start).map((v, idx) => v + idx * 5);
            if (min !== steps[0]) {
                steps.unshift(min);
            }
            if (max !== steps[steps.length - 1]) {
                steps.push(max);
            }
            const div = document.createElement('div');
            div.style.width = '100%';
            div.style.height = '100%';
            div.style.position = 'relative';
            div.style.display = 'flex';
            div.style.justifyContent = 'space-between';
            let scaleHtml = '';
            for(var step of steps) {
                scaleHtml += `
                        <div style="width: 15px; cursor: pointer" my-term="${step}">${step}</div>
                    `
            }
            div.innerHTML = scaleHtml;
            this.innerHTML = '';
            this.appendChild(div);
        }
    }
});

